import { extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "This field should not be left blank!",
  computesRequired: true
});

extend("email", {
  ...email,
  message: "This field must be a valid email"
});
